import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/pages/notification/notification.service';
import { UserFlowService } from 'src/app/services/common/user-flow.service';

@Component({
  selector: 'app-user-flow',
  templateUrl: './user-flow.component.html',
  styleUrl: './user-flow.component.scss',
})
export class UserFlowComponent {
  constructor(
    private readonly userFlowService: UserFlowService,
    private readonly notifyService: NotificationService,
    public dialogRef: MatDialogRef<UserFlowComponent>
  ) {}

  completeTour() {
    this.notifyService.updateUserAlertSettings({
      receive_in_app_alert:
        this.notifyService.userAlertSettings.receive_in_app_alert,
      receive_email_alert:
        this.notifyService.userAlertSettings.receive_email_alert,
      has_seen_user_guide: true,
    });
  }

  startTour() {
    this.userFlowService.startTour();
    this.completeTour();
    this.dialogRef.close();
  }
  skip() {
    this.dialogRef.close();
  }
}
